var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-card-component-layout',{attrs:{"renderData":_vm.renderData},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return _c(_vm.renderData.cardType,{tag:"component",attrs:{"item":item},on:{"card-clicked":_vm.handleCardClick}})}}])})}
var staticRenderFns = []

export { render, staticRenderFns }